"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

exports.__esModule = true;

var _Advertisement = _interopRequireDefault(require("./Advertisement"));

exports.default = _Advertisement.default;


//////////////////
// WEBPACK FOOTER
// ./~/semantic-ui-react/dist/commonjs/views/Advertisement/index.js
// module id = 1530
// module chunks = 0